import { ApiOutlined } from '@ant-design/icons';

import styles from '../StepIntro.module.scss';

export const StepIntroHeader = () => (
  <div className={styles.header}>
    <div className={styles.headerIcon}>
      <ApiOutlined className={styles.icon} />
    </div>
    <div className={styles.headerText}>
      <p className={styles.title}>Automate your room inventory</p>
      <p className={styles.subtitle}>
        Reduce manual updates: sync availability and BAR automatically.
      </p>
    </div>
  </div>
);
